export const measureEpisodePageCount = (
  contentElement: HTMLElement,
  viewportHeight: number
): number => {
  if (!contentElement || viewportHeight <= 0) return 1;

  const previousColumnWidth = contentElement.style.columnWidth;
  const previousHeight = contentElement.style.height;
  const previousWidth = contentElement.style.width;

  contentElement.style.columnWidth = 'auto';
  contentElement.style.height = 'auto';
  contentElement.style.width = '100vw';

  const totalContentHeight = contentElement.scrollHeight;
  const safePages = Math.ceil(totalContentHeight / viewportHeight);
  const normalizedPages = safePages > 0 ? safePages : 1;

  contentElement.style.columnWidth = previousColumnWidth || '100vw';
  contentElement.style.height = previousHeight || '100%';
  contentElement.style.width = previousWidth || `${normalizedPages * 100}vw`;

  return normalizedPages;
};
